import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { useState } from "react";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import SelectElement from "../components/event-selection/selectElement";
import Input from "../components/event-selection/Input";
import TextArea from "../components/event-selection/textArea";
import Checkboxes from "../components/event-selection/checkboxes";
import SelectAndQmark from "../components/event-selection/select&Qmark";
import Loaing from "../icons/loaing";
import HealthEventsServie from "../services/healthEventsService";
import postEvent from "../services/eventService";
import ConfirmModal from "../components/ConfirmModal";
import FormBorder from "../components/formBorder";
import CalendarIcon from "../icons/calendar";
import CustomCheckboxes from "../components/event-selection/customCheckboxes";
import moment from "moment";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { HealthEventPDF } from "../components/dashboard/healthevent-pdf";

export type healthInputsTypes = {
  reporting: string;
  eventDate: string;
  eventTime: Date;
  eventMoment: string;
  eventType: string[];
  eventLocation: string;
  eventDescription: string;
  emsContacted: string;
  hospitalization: string[];
  localAuthorityBeNotified: string;
  localAuthorityBeenNotified: string;
  parentsBeenInformed: string;
  securityLevel: string;
  aftercare: string;
  childAbsence: string;
  supervisionRateRespected: string;
  usualTeam: string;
  professionalNames: string;
  riskRelatedEventArray?: string[];
  riskRelatedEvent: string;
  ageOfChild: string;
  insuranceBeNotified: string;
  insuranceBeenNotified: string;
  printeventDate?: boolean;
  printeventTime?: Date;
  printeventMoment?: boolean;
  printeventType?: boolean;
  printeventLocation?: boolean;
  printeventDescription?: boolean;
  printemsContacted?: boolean;
  printhospitalization?: boolean;
  printlocalAuthorityBeNotified?: boolean;
  printlocalAuthorityBeenNotified?: boolean;
  printparentsBeenInformed?: boolean;
  printsecurityLevel?: boolean;
  printaftercare?: boolean;
  printchildAbsence?: boolean;
  printsupervisionRateRespected?: boolean;
  printusualTeam?: boolean;
  printprofessionalNames?: boolean;
  printriskRelatedEventArray?: boolean;
  printriskRelatedEvent?: boolean;
  printageOfChild?: boolean;
  printinsuranceBeNotified?: boolean;
  printinsuranceBeenNotified?: boolean;
};

const schema = yup.object({
  eventDate: yup.date().required(),
  eventTime: yup.string().required(),
  eventMoment: yup.string().required(),
  eventType: yup.string().required(),
  hospitalization: yup.string().required(),
  eventLocation: yup.string().required(),
  eventDescription: yup.string().required(),
  emsContacted: yup.string().required(),
  localAuthorityBeNotified: yup.string().required(),
  localAuthorityBeenNotified: yup.string().required(),
  parentsBeenInformed: yup.string().required(),
  securityLevel: yup.string().required(),
  aftercare: yup.string().required(),
  childAbsence: yup.string().required(),
  supervisionRateRespected: yup.string().required(),
  usualTeam: yup.string().required(),
  professionalNames: yup.string().required(),
  riskRelatedEventArray: yup
    .array()
    .min(1, "riskRelatedEvent is a required field!")
    .test(
      "no-empty-strings",
      "Array cannot contain empty string values",
      (value) => {
        return new Promise((resolve) => {
          resolve(value?.every((item) => item !== "") ?? false);
        });
      }
    ),
  ageOfChild: yup.string().required(),
  insuranceBeNotified: yup.string().required(),
  insuranceBeenNotified: yup.string().required(),
});

const HealthEvents = () => {
  const [loading, setLoading] = useState(false);
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [startDate, setStartDate] = useState<null | Date>(null);
  const [pdfData, setPdfData] = useState<any>(null);

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<healthInputsTypes>({ resolver: yupResolver(schema) });

  const { t } = useTranslation();

  const handleDownload: SubmitHandler<healthInputsTypes> = async (data) => {
    data.riskRelatedEvent =
      data.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
    data.eventDate = moment(startDate).format("YYYY-MM-DD");
    data.printriskRelatedEvent = data.printriskRelatedEventArray;
    setPdfData(data);
  };

  const resetForm = () => {
    setConfirmModalVisible(false);
    setPdfData(null);
    reset();
  };

  const onSubmit: SubmitHandler<healthInputsTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printaftercare,
        printageOfChild,
        printriskRelatedEvent,
        printchildAbsence,
        printemsContacted,
        printeventDate,
        printeventDescription,
        printeventLocation,
        printeventMoment,
        printeventTime,
        printeventType,
        printhospitalization,
        printinsuranceBeNotified,
        printinsuranceBeenNotified,
        printlocalAuthorityBeNotified,
        printlocalAuthorityBeenNotified,
        printparentsBeenInformed,
        printprofessionalNames,
        printriskRelatedEventArray,
        printsecurityLevel,
        printsupervisionRateRespected,
        printusualTeam,
        ...rest
      } = data;
      rest.riskRelatedEvent =
        rest.riskRelatedEventArray?.map((value) => value).join("-,-") ?? "";
      rest.eventDate = moment(startDate).format("YYYY-MM-DD");
      delete rest.riskRelatedEventArray;
      const response = await HealthEventsServie({
        ...rest,
      });

      if (response.message === "created") {
        console.log("Health event created with security level:", rest.securityLevel);
        const eventpost = await postEvent({
          eventId: response.data._id,
          severity: rest.securityLevel,
          eventDetailsDate: response.data.eventDate,
        });
        
        if (eventpost.message === "created") {
          toast.success("health event created successfully!");
          setLoading(false);
          navigate("/confirm");
        } else {
          setLoading(false);
          toast.error("Error creating health event reporting");
        }
      } else {
        setLoading(false);
        toast.error("Error creating health event");
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };
  return (
    <section className="relative font-Poppins px-[20px] lg:px-0">
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans t={t}>Health event</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans t={t}>
              Please report here health events relathed to the child
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end lg:mx-[20px] mb-10 gap-[15px]">
          <button
            type="button"
            className="px-5 py-2 rounded-full  text-white bg-[#1E408E]"
            onClick={() => setConfirmModalVisible(true)}
          >
            <Trans t={t}>Reset</Trans>
          </button>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<HealthEventPDF formData={pdfData ?? {}} />}
              fileName={"health-event.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>
        <FormBorder>
          <div className="grid gap-5">
            <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0 ">
              <label
                htmlFor="eventDate"
                className="font-normal text-xl text-[#1E408E]"
              >
                <Trans t={t}>Health incident date</Trans>
              </label>
              <div className=" pr-10">
                <div className="flex flex-row">
                  <div className="mr-4 bg-white w-full flex items-center border border-[#8692A6] h-12 p-2 rounded">
                    <Controller
                      control={control}
                      {...register(`eventDate`)}
                      name="eventDate"
                      render={({ field }) => (
                        <DatePicker
                          filterDate={(d) => {
                            return new Date() > d;
                          }}
                          selectsRange={false}
                          onChange={(date: Date) => {
                            field.onChange(date?.toDateString());
                            setStartDate(date);
                          }}
                          placeholderText="mm/dd/yyyy"
                          selected={startDate}
                          dateFormat={"dd MMM yyyy"}
                          isClearable={false}
                          className="w-full border-none p-0 bg-white focus:outline-none"
                        />
                      )}
                    />
                    <CalendarIcon />
                  </div>
                  <input
                    type="checkbox"
                    {...register("printeventDate")}
                    defaultChecked
                    id={"printeventDate"}
                  />
                </div>
                {errors["eventDate"] && (
                  <p className="text-red-500 mt-2 text-sm">
                    {errors["eventDate"]?.message}
                  </p>
                )}
              </div>
            </div>
            <Input
              type="Time"
              printEnabled
              register={register}
              errors={errors}
              name="eventTime"
              label="Health incident time"
              placeholder="hh:mm"
              translateId="Health incident time"
            />
            <SelectElement
              register={register}
              printEnabled
              errors={errors}
              name="eventMoment"
              label="Activity during time of Health incident"
              options={[
                "Play time",
                "Sleep time",
                "Changing/care time",
                "Meal time",
                "Reception time (morning and evening)",
              ]}
              translateId="Activity during time of Health incident"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="eventLocation"
              label="Health Incident location"
              options={[
                "Interior (School indoor premise)",
                "Exterior space (School outdoor premise)",
                "Outside the establishment",
              ]}
              translateId="Health Incident location"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="ageOfChild"
              label="Age of the child involved in the incident"
              options={[
                "Less than 1 year",
                "1 to 2 years",
                "2 to 3 years",
                "3 to 4 years",
                "4 to 5 years",
                "5 to 6 years",
                "More than 6 years old",
              ]}
              translateId="Aga of the child"
            />
            <Checkboxes
              printEnabled
              register={register}
              errors={errors}
              name="eventType"
              options={[
                { text: "Skin rash" },
                { text: "Convulsion" },
                { text: "Fever" },
                { text: "Vomiting" },
                { text: "Respiratory problem" },
                { text: "Pain" },
                { text: "Unwellness" },
                { text: "Bleeding" },
                { text: "Other health event" },
              ]}
              label="Health Incident type"
              translateId="Health Incident type"
            />
            <TextArea
              printEnabled
              register={register}
              errors={errors}
              name="eventDescription"
              label="eventDescription"
              translateId="eventDescription"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="emsContacted"
              label="EMS contacted"
              options={["Yes", "No"]}
              translateId="EMS contacted"
            />

            <Checkboxes
              printEnabled
              register={register}
              errors={errors}
              name="hospitalization"
              options={[
                { text: "No" },
                { text: "Less than 24H" },
                { text: "Less than 36H" },
                { text: "Less than 48H" },
                { text: "More than 48H" },
              ]}
              label="Any Hospitalization (including emergency room)"
              translateId="hospitalization"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="aftercare"
              label="Aftercare"
              options={[
                "none",
                "Yes, for few days",
                "Yes, for few weeks",
                "Yes, for few months",
                "Yes, for more than a year",
              ]}
              translateId="Aftercare"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="childAbsence"
              label="Child absence"
              options={[
                // "No absence",
                // "Returned the next day",
                // "Absence of 1 to 3 days",
                // "Absence for more than 3 days",
                // "Parents have terminated the contract",
                "No absence or maximum 1 day",
                "Maximum 2 days",
                "Maximum 3 days",
                "Maximum 1 week",
                "More than one week",
                "Parents terminated the care agreement",
              ]}
              translateId="Child absence"
            />
            <SelectAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="securityLevel"
              label="Severity level"
              options={[0, 1, 2, 3, 4, 5]}
              translateId="Severity level"
              i18nKey="Help Box - Health Event - Severity level"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="parentsBeenInformed"
              label="parentsBeenInformed"
              options={["Yes", "No"]}
              translateId="parentsBeenInformed"
            />
            <SelectAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="insuranceBeNotified"
              label="Will insurance claim be filed?"
              options={["Yes", "No"]}
              translateId="insuranceBeNotified"
              i18nKey="Help Box - Health Event - Does our Company Insurance need to be informed?"
            />

            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="insuranceBeenNotified"
              label="Has the insurance claim been filed?"
              options={["Yes", "No"]}
              translateId="insuranceBeenNotified"
            />

            <SelectAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="localAuthorityBeNotified"
              label="Should the local authority be notified?"
              options={["Yes", "No"]}
              i18nKey="Help Box - Health Event - Does the local authority need to be informed?"
              translateId="localAuthorityBeNotified"
            />
            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="localAuthorityBeenNotified"
              label="Has the local authority been notified?"
              options={["Yes", "No"]}
              translateId="localAuthorityBeenNotified"
            />

            <SelectAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="supervisionRateRespected"
              label="supervisionRateRespected"
              options={["Yes", "No"]}
              translateId="supervisionRateRespected"
              i18nKey="Help Box - Health Event - When the event occurred, was the staff ratio in compliance with regulations?"
            />

            <SelectElement
              printEnabled
              register={register}
              errors={errors}
              name="usualTeam"
              label="Usual team in the reception area ?"
              options={["Yes", "No"]}
              translateId="usualTeam"
            />
            <TextArea
              printEnabled
              register={register}
              errors={errors}
              name="professionalNames"
              label="Name of all staff involved when the incident took place"
              translateId="professionalNames"
            />
            <CustomCheckboxes
              printEnabled
              register={register}
              errors={errors}
              name="riskRelatedEventArray"
              label="Risks related to the Health incident"
              options={[
                {
                  text: "Risk of parents negatively influencing other parents in the school",
                },
                {
                  text: "Risk that parents will give bad publicity (social networks, negative comments on the internet)",
                },
                { text: "Legal risk (lawsuit)" },
                { text: "Risk of partial closure of the school" },
                { text: "Risk of temporary closure of the school" },
                { text: "none" },
              ]}
            />
          </div>
        </FormBorder>
        <div className="flex justify-end lg:px-[20px] mt-10">
          <button
            type={"submit"}
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
          >
            <Trans i18nKey="Submit">Submit</Trans>
          </button>
          {loading && <Loaing />}
        </div>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default HealthEvents;
